<template>
  <autocomplete-multiple name="Фискальный регистратор" :items="items" :select.sync="localSelect" @load="load" :loading="loadState.isLoading">
    <template v-slot:itemIcon="{item}">
      <v-sheet rounded color="grey lighten-4" class="caption px-1 mr-2">{{item.sid}}</v-sheet>
    </template>
  </autocomplete-multiple>
</template>

<script>
import State from "@/plugins/state";
import {
  Entity_AccountPlan,
} from "../../../EntityStoreCacheService";
import AutocompleteMultiple from "@/componentsV2/base/AutocompleteMultiple.vue";

export default {
  components: {AutocompleteMultiple},
  props:[
    'select',
  ],
  data:()=>({
    loadState: new State(),
    items: [],
    localSelect: null
  }),
  watch: {
    select() {
      this.localSelect = this.select;
    },
    localSelect() {
      this.$emit('update:select', this.localSelect)
    }
  },
  mounted() {
    this.localSelect = this.select;
  },
  methods:{
    load(){
      new Entity_AccountPlan()
      .selects(Entity_AccountPlan.id)
      .selects(Entity_AccountPlan.sid)
      .selects(Entity_AccountPlan.name)
      .order(Entity_AccountPlan.name, true)
      .page(null)
      .addStateCallback((v)=> this.loadState.setRequestBuilderState(v))
      .request((v)=>{
        this.items = v.items.map(item => ({
          ...item,
          _selected_name: item.sid+" - "+item.name
        }));
      }, (e)=>{
        console.error(e.response.data.message);
        this.$store.commit('alertError', 'Ошибка загрузки данных.Если ошибка повторяется, обратитесь в тех. поддержку');
      }) 
    }
  }
}
</script>